import { configureStore } from '@reduxjs/toolkit';

const configureWidgetStore = ({ preloadedState, reducer, middleware = [] }) => {
  return configureStore({
    preloadedState,
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [ 'propsData', 'error' ],
      },
    }).concat(middleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
};

export default configureWidgetStore;
